export default __webpack_public_path__ + "static/frame-2230-fbdf231adc1d12c3dc66c2b220dec549.png";